import FormError from './FormError';
import TitledPanel from './TitledPanel';
import DateFnsUtils from '@date-io/date-fns';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';

class GetDateValueDialog extends React.Component {

    state = {
        open: false,
        existing: false,
        date: Date.now(),
        existingValues: [],
        invalid: false,
        error: false
    };

    // Need to check if an incoming revision causes a duplicate
    static getDerivedStateFromProps(props, state) {
        if (props.existingValues && props.existingValues.length > 0) {
            if (props.existingValues.length === state.existingValues.length) {
                const hasChanged = props.existingValues.some(ev => !state.existingValues.includes(ev));
                if (!hasChanged) return null;
            }
            return { needsValidating: true, existingValues: props.existingValues };
        }
        return null;
    }

    componentDidUpdate() {
        if (this.state.needsValidating) this.checkValidity();
    }

    handleClickOpen = () => {
        this.setState({ open: true }, this.checkValidity);
    };

    addLiteral = () => {
        this.setState({ open: false });
        const tempDate = new Date(this.state.date);
        const date =
            tempDate.getFullYear() + "-" +
            ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-" +
            ("0" + tempDate.getDate()).slice(-2);
        this.props.onSetDate(date, "http://www.w3.org/2001/XMLSchema#date");
        this.setState({ date: Date.now() });
    };

    exitAddLiteral = () => this.setState({ open: false, date: Date.now() });

    checkValidity() {
        let existing = false;
        let invalid = false;
        const tempDate = new Date(this.state.date);
        if (this.state.date === null) invalid = true;
        if (tempDate.toString() === "Invalid Date") invalid = true;
        const date =
            tempDate.getFullYear() + "-" +
            ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-" +
            ("0" + tempDate.getDate()).slice(-2);
        if (this.props.existingValues.includes(date)) existing = true;
        this.setState({ existing, invalid, needsValidating: false });
    }

    handleChange = (date) => this.setState({ date, invalid: true }, this.checkValidity);

    render() {

        const { date, existing, invalid } = this.state;
        const { classes } = this.props;

        return (
            <React.Fragment>
                <AddButton dataTest="add-date" title="Add a date" onClick={this.handleClickOpen} />
                <Dialog
                    className={classes.dialog}
                    open={this.state.open}
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    onClose={this.exitAddLiteral}
                    aria-labelledby="createdate-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createdate-dialog-title">Pick a Date</DialogTitle>
                    <DialogContent>
                        <TitledPanel title="Date">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    data-test="date-picker"
                                    className={classes.datepicker}
                                    format="yyyy/MM/dd"
                                    margin="dense"
                                    id="date-picker-inline"
                                    value={date}
                                    inputVariant="outlined"
                                    onChange={this.handleChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Select date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                            {existing && <FormError>This value already exists.</FormError>}
                        </TitledPanel>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddLiteral} />
                        <PrimaryButton disabled={existing || invalid} onClick={this.addLiteral}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

GetDateValueDialog.propTypes = {
    title: PropTypes.string.isRequired,
    existingValues: PropTypes.array,
    onSetDate: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(GetDateValueDialog);
